import { useParams } from "react-router-dom"
import { useGetRefundTicketsOrderMutation, useGetResendTicketsMutation, useGetTicketsOrderDitailsQuery } from "../../features/CallApi"
import { Alert, Button, ButtonGroup, Card, Col, Container, Row, Spinner } from "react-bootstrap"
import { format } from "date-fns"
import { TicketsOrderStatus } from "./TicketsOrderStatus"
import { useEffect, useState } from "react"

export const TicketsOrderDetails = ({ role }) => {

    const { id } = useParams()
    const { data, isLoading, isError, refetch } = useGetTicketsOrderDitailsQuery(id)
    const [getRefundTicketsOrder, { isLoading: isRefunding }] = useGetRefundTicketsOrderMutation()
    const [getResendTickets, { isLoading: isResending }] = useGetResendTicketsMutation()
    const [items, setItems] = useState([])
    const [successMessage, setSuccessMessage] = useState()
    const [errorMessage, setErrorMessage] = useState()

    useEffect(() => {
        console.log(role)
    }, [role])

    useEffect(() => {
        // if (data) {
        if (data?.ticketsOrderItems.length > 0) {
            setItems(data.ticketsOrderItems)
        }
        // }
    }, [data])

    const setError = (msg) => {
        setErrorMessage(msg)
        // setTimeout(() => {
        //     setErrorMessage(null)
        // }, 3000);
    }

    const setSuccess = (msg) => {
        setSuccessMessage(msg)
        // setTimeout(() => {
        //     setSuccessMessage(null)
        // }, 3000);
    }

    const resendTickets = () => {
        getResendTickets(id)
            .then((r) => {
                // refetch()
                if (r.error) {
                    return setError("Возникла ошибка, обратитесь к администратору")
                }
                setSuccess("Билеты отправлены повторно")
            })
            .catch(() => {
                setError("Возникла ошибка, обратитесь к администратору")
            })
    }

    const refundTickets = () => {
        if (window.confirm("Вернуть оплату?")) {
            getRefundTicketsOrder(id)
                .then(((r) => {
                    refetch()
                    if (r.error) {
                        return setError("Возникла ошибка, обратитесь к администратору")
                    }
                    setSuccess("Возврат проведен успешно")
                }
                ))
                .catch((e) => {
                    setError("Возникла ошибка, обратитесь к администратору")
                })
        }
    }

    return (
        <Container>
            {!isLoading ?
                <>
                    {data &&
                        <>

                            <Card>
                                <Card.Header>

                                    <div className="fs-5">
                                        Заказ № {data.id}
                                    </div>
                                    <div>
                                        <b>Код в Премьере: {data.reservationId}</b>
                                    </div>
                                    <div>
                                        Покупатель: {data.client.lastName} {data.client.firstName} {data.client.patronymic}
                                    </div>
                                    <div>
                                        E-Mail: {data.client.email}
                                    </div>
                                    <div>
                                        Телефон: {data.client.phone}
                                    </div>
                                    <div>
                                        Дата создания: {format(new Date(data.createDateTime), "HH:mm:ss dd.MM.yyyy")}
                                    </div>
                                    <div>
                                        Время оплаты: {data.paidDateTime ? <>{format(new Date(data.createDateTime), "HH:mm:ss dd.MM.yyyy")}</> : "-"}
                                    </div>
                                    <div>
                                        Статус: <TicketsOrderStatus status={data.status} />
                                    </div>
                                    {data.bankSessionId &&
                                        <>

                                            <div className="border-top">
                                                ID транзакции: {data.bankSessionId}
                                            </div>
                                            <div>
                                                Карта покупателя: {data.clientCardNumber}
                                            </div>
                                        </>
                                    }
                                    {data.status === 2 &&
                                        <>
                                            <div className="border-top">
                                                Отправлен билет: {data.isSendTickets ? <span>Да</span> : <span>Нет</span>}
                                            </div>
                                            <div>
                                                Отправлен чек: {data.isSendReceipt ? <span>Да</span> : <span>Нет</span>}
                                            </div>
                                            <div>
                                                Распечатан билет: {data.isPrinted ? <span>Да <b>(в {format(new Date(data.timePrinted), "HH:mm dd.MM.yyyy")})</b></span> : <span>Нет</span>}
                                            </div>
                                            <ButtonGroup size="sm" className="mt-3">
                                                {(role === "Admins" || role === "Buh") &&
                                                    <Button onClick={() => { refundTickets() }} disabled={isRefunding}> {!isRefunding ? "Возврат оплаты" : <Spinner size="sm" />} </Button>
                                                }
                                                {data.isSendTickets && <Button disabled={isResending} onClick={() => resendTickets()}>{!isResending ? "Отправить билет" : <Spinner size="sm" />}</Button>}
                                            </ButtonGroup>
                                        </>
                                    }

                                    <div className="mt-3">
                                        {successMessage && <Alert onClose={() => { setSuccess(null) }} variant="success" dismissible>{successMessage}</Alert>}
                                        {errorMessage && <Alert onClose={() => { setError(null) }} variant="danger" dismissible>{errorMessage}</Alert>}
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div>
                                        Мероприятие: {data.nameInPremiera}
                                    </div>
                                    <div>
                                        Дата: {format(new Date(data.startOfEvent), "HH:mm dd.MM.yyyy")}
                                    </div>
                                    <div>Состав заказ:</div>
                                    <Row>
                                        {/* <Col>Название</Col> */}
                                        <Col>Категория</Col>
                                        <Col>Ряд</Col>
                                        <Col>Место</Col>
                                        <Col>Цена</Col>
                                    </Row>
                                    <div className="border-bottom"></div>
                                    {items.map(item =>
                                        <Row key={item.id} className="mt-2 mb-2">
                                            {/* <Col>{item.nameInPremiera}</Col> */}
                                            <Col>{item.category}</Col>
                                            <Col>
                                                {item.row}
                                            </Col>
                                            <Col>
                                                {item.place}
                                            </Col>
                                            <Col>
                                                {item.price}
                                            </Col>
                                        </Row>
                                    )}
                                </Card.Body>
                            </Card>
                        </>
                    }
                </>
                :
                <>

                </>
            }
        </Container>
    )
}